import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

function InfoCircle({ label = '', value = false }) {
  return (
    <Box textAlign="center">
      <Box sx={{ lineHeight: '1em' }}>
        {value === true ? (
          <CheckCircleIcon color="success" />
        ) : (
          <CancelIcon color="error" />
        )}
      </Box>
      <Typography variant="caption" component="div">
        {label}
      </Typography>
    </Box>
  );
}

export default InfoCircle;
